import { FiMail, FiPhone, FiMapPin, FiSend } from "react-icons/fi/index.js";
import "../styles/contact.css";

const Contact = () => {
    return (
        <div className="contact-wrapper">
            <div className="contact-container">
                {/* Left Side: Contact Information */}
                <div className="contact-info-section">
                    <h1 className="contact-title">Let's get in touch.</h1>
                    <p className="contact-sub">We'd love to hear from you. Drop us a message and we'll reply as soon as possible.</p>
                    
                    <div className="info-cards">
                        <div className="info-card">
                            <div className="icon-wrapper">
                                <FiMail />
                            </div>
                            <div className="info-details">
                                <h3>Email Us</h3>
                                <p>hello@cravedash.com</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="icon-wrapper">
                                <FiPhone />
                            </div>
                            <div className="info-details">
                                <h3>Call Us</h3>
                                <p>+91 98765 43210</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="icon-wrapper">
                                <FiMapPin />
                            </div>
                            <div className="info-details">
                                <h3>Our Location</h3>
                                <p>123 Food Street, Cyber Hub, New Delhi</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side: Form */}
                <div className="contact-form-section">
                    <div className="form-card">
                        <h2>Send a Message</h2>
                        <form className="pro-form" onSubmit={(e) => e.preventDefault()}>
                            <div className="input-row">
                                <div className="input-group">
                                    <label htmlFor="name">Full Name</label>
                                    <input type="text" id="name" placeholder="John Doe" required />
                                </div>
                                <div className="input-group">
                                    <label htmlFor="email">Email Address</label>
                                    <input type="email" id="email" placeholder="john@example.com" required />
                                </div>
                            </div>

                            <div className="input-group">
                                <label htmlFor="subject">Subject</label>
                                <input type="text" id="subject" placeholder="How can we help you?" required />
                            </div>

                            <div className="input-group">
                                <label htmlFor="message">Your Message</label>
                                <textarea id="message" rows="5" placeholder="Write your message here..." required></textarea>
                            </div>

                            <button type="submit" className="pro-submit">
                                <span>Send Message</span>
                                <FiSend className="btn-icon" />
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;